// extracted by mini-css-extract-plugin
export default {"hightlightWrapper":"CircleOccupancyHighlight_hightlightWrapper__rSxLQ"};